var _defs, _circle, _g, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliedIntelligenceLuminousBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 720",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "core"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#087CFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1090,
    cy: 345,
    r: 420,
    fill: "url(#core)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.14,
    transform: "translate(1080 350)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 405,
    ry: 325
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 330,
    ry: 266
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 260,
    ry: 208,
    strokeDasharray: "3 8"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1360,
    cy: 174,
    r: 3.5,
    fill: "#FF2775"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 728,
    cy: 610,
    r: 3,
    fill: "#087CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIntelligenceLuminousBackground);
export default __webpack_public_path__ + "static/media/applied-intelligence-luminous-background.7b23f1157c39c3aebabd49939c70e8b4.svg";
export { ForwardRef as ReactComponent };